import { mapValues, pick } from 'lodash';

const pickWithDefault = (obj, keys) => {
    return mapValues(pick(obj, keys), value => value !== undefined ? value : '');
};

export default pickWithDefault;
